export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_17-1574d0490c3849b40700ac64391c65e9.jpg";